'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CcAddAwsContractPrepareCtrl', function ($scope, $state) {

  $scope.next = function()
  {
    $state.go('authorized.teams.contracts.add-aws.connect');
  };
});
